<template>
  <div id="openPlatform">
    <SideNav ref="leftMenuObj" style="position: fixed; left: 0; top: 0; width: 64px; height: 100vh; z-index: 1000;"></SideNav>
    <div class="gr-content-container">
      <div class="personalHeader">
        <top-header>
          <div slot="setup-header-left" class="setup-header-left">
            <span class="setup-header-left-icon">
              <i class="iconfont guoran-tongyichicun-zidingyi"></i>
            </span>
            <span>{{$t('openPlatform.title')}}{{ currentPageTitle }}</span>
          </div>
        </top-header>
      </div>
      <div class="content">
        <div class="manage-nav-section">
          <ManangeNav></ManangeNav>
        </div>
        <div class="content-section">
          <!-- 添加调试信息 -->
          <div v-if="$route.path === '/openPlatform'" style="padding: 20px; text-align: center;">
            <h3>{{$t('openPlatform.title')}}{{$t('openPlatform.homepage')}}</h3>
            <p>{{$t('openPlatform.currentPath')}}: {{ $route.path }}</p>
            <p>{{$t('openPlatform.selectMenuTip')}}</p>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "@/views/menu/SideNav.vue";
import TopHeader from "@/components/top-header.vue";
import ManangeNav from "@/views/menu/ManageNave.vue";

export default {
  name: "OpenPlatform",
  components: {
    SideNav,
    TopHeader,
    ManangeNav
  },
  computed: {
    currentPageTitle() {
      const path = this.$route.path;
      if (path === '/openPlatform/appManage') {
        return ' - ' + this.$t('openPlatform.appManage');
      } else if (path === '/openPlatform/sso') {
        return ' - ' + this.$t('openPlatform.ssoManage');
      } else if (path === '/openPlatform') {
        return '';
      }
      return '';
    }
  },
  mounted() {
    console.log('OpenPlatform mounted, current route:', this.$route.path);
  },
  watch: {
    '$route'(to, from) {
      console.log('Route changed from', from.path, 'to', to.path);
    }
  }
};
</script>

<style scoped lang="less">
#openPlatform {
  position: relative;
  
  .gr-content-container {
    position: absolute;
    left: 64px;
    width: calc(100vw - 96px);
    height: calc(100vh - 24px);
    padding: 12px 16px;
    min-width: 1000px;
    overflow-x: auto;
    text-align: left;
    z-index: 1; /* 确保内容在SideNav下面 */

    .content {
      width: 100%;
      height: calc(100% - 84px);
      margin-top: 16px;
      overflow-y: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: row;

      .manage-nav-section {
        width: 300px;
        flex: none;
        margin-right: 16px;
        overflow: hidden;
        box-shadow: 0px 0px 18px 0px rgba(29, 55, 129, 0.07);
        border-radius: 5px;
        background-color: white;
      }

      .content-section {
        flex: auto;
        overflow: hidden;
        /*box-shadow: 0px 0px 18px 0px rgba(29, 55, 129, 0.07);*/
        border-radius: 5px;
        min-height: 400px; /* 确保有最小高度 */
        position: relative; /* 添加相对定位 */
      }
    }
  }
}

/* 添加全局样式确保内容可见 */
:deep(.app-manage) {
  color: #333 !important;
  background-color: transparent !important;
  
  .content-box {
    padding: 20px;
    min-height: 100%;
  }
  
  .page-header {
    h2 {
      color: #303133 !important;
      font-size: 20px;
      margin-bottom: 8px;
    }
    
    p {
      color: #909399 !important;
      font-size: 14px;
    }
  }
  
  .toolbar {
    margin-bottom: 16px;
  }
  
  .el-table {
    .el-table__header {
      background-color: #f5f7fa !important;
    }
    
    .el-table__body {
      background-color: white !important;
    }
    
    .cell {
      color: #333 !important;
    }
  }
}
</style> 